import { useMemo } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import { ZAPPOS_MERCHANTID } from 'constants/crossSiteMerchantIdMapping';
import { FEATURE_PERCENT_DISCOUNT_SORT } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

/**
 * Hook that returns filtered sort options based on merchant and feature flag conditions.
 * Removes 'percentOff-desc' sort option for Zappos when the percent discount sort feature is disabled.
 *
 * @returns {Array} Filtered array of sort options from marketplace context
 */
export const useFilteredSortOptions = () => {
  const {
    marketplace: {
      merchantId,
      search: { sortOptions }
    }
  } = useMartyContext();
  const { isEnrolled: isFeaturePercentOffEnabled } = useIsEnrolledInVariant(FEATURE_PERCENT_DISCOUNT_SORT);
  const shouldRemovePercentOff = merchantId === ZAPPOS_MERCHANTID && !isFeaturePercentOffEnabled;

  const memoizedOptions = useMemo(
    () => (shouldRemovePercentOff ? sortOptions.filter(({ value }) => value !== 'percentOff-desc') : sortOptions),
    [sortOptions, shouldRemovePercentOff]
  );

  return memoizedOptions;
};
